(function () {
  'use strict';

  // Variants that must never exceed quantity 1 across the whole cart.
  // Source of truth: agent_context.json + brand_rules.NOT_FOR_SALE_PRODUCTS.
  var ASCEND_VARIANT_IDS = [50787318432059];

  var running = false;       // reentry guard
  var enforcedCount = 0;     // diagnostic counter
  var lastFingerprint = '';  // skip when cart hasn't changed since last enforce

  function fetchJson(url, options) {
    var opts = Object.assign({ credentials: 'same-origin', cache: 'no-store' }, options || {});
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  function fingerprintAscend(cart) {
    return cart.items
      .filter(function (i) { return ASCEND_VARIANT_IDS.indexOf(i.variant_id) !== -1; })
      .map(function (i) { return i.key + ':' + i.quantity; })
      .join(',');
  }

  function enforce() {
    if (running) return Promise.resolve(false);
    running = true;
    return fetchJson('/cart.js')
      .then(function (cart) {
        var ascendLines = cart.items.filter(function (i) {
          return ASCEND_VARIANT_IDS.indexOf(i.variant_id) !== -1;
        });
        if (ascendLines.length === 0) {
          lastFingerprint = '';
          return false;
        }

        var totalQty = ascendLines.reduce(function (sum, i) { return sum + i.quantity; }, 0);
        if (totalQty <= 1) {
          // Cart already at limit. Cache to skip churn on chatty events.
          lastFingerprint = fingerprintAscend(cart);
          return false;
        }

        // Cart is over-limit. Skip cache check — always reduce.
        var fp = fingerprintAscend(cart);
        if (fp === lastFingerprint) {
          // Same over-limit state we already attempted to reduce — likely the
          // /cart/update.js is failing repeatedly. Bail to avoid spin.
          console.warn('[ascend-limit] same over-limit fingerprint as last attempt, skipping');
          return false;
        }
        lastFingerprint = fp;

        // Keep first line at qty=1, remove others (qty=0 deletes the line).
        var updates = {};
        var kept = false;
        ascendLines.forEach(function (line) {
          if (!kept) {
            updates[line.key] = 1;
            kept = true;
          } else {
            updates[line.key] = 0;
          }
        });

        return fetchJson('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          enforcedCount++;
          // After reduction, expected fingerprint is one line at qty 1.
          lastFingerprint = ascendLines[0].key + ':1';
          console.log('[ascend-limit] reduced Ascend to qty 1 (event #' + enforcedCount + ')');
          // Refresh drawer + any cart UI subscribed to cart:build.
          document.dispatchEvent(new CustomEvent('cart:build'));
          // Update header bubble too.
          return fetchJson('/cart.js').then(function (c) {
            document.querySelectorAll('.cart-link__bubble-num, [data-cart-count]').forEach(function (el) {
              el.textContent = c.item_count;
            });
            var bubble = document.querySelector('.cart-link__bubble');
            if (bubble) bubble.classList.toggle('cart-link__bubble--visible', c.item_count > 0);
            return true;
          });
        });
      })
      .catch(function (err) {
        console.warn('[ascend-limit] error:', err && err.message);
        return false;
      })
      .then(function (result) { running = false; return result; });
  }

  function debouncedEnforce() {
    setTimeout(enforce, 150);
  }

  // Subscribe to all cart change events Impulse fires.
  document.addEventListener('cart:updated', debouncedEnforce);
  document.addEventListener('cart:quantity.cart-cart-drawer', debouncedEnforce);
  document.addEventListener('cart:quantity.cart-header', debouncedEnforce);
  document.addEventListener('cart:build', debouncedEnforce);

  // Sweep once on page load to catch stale cart state from prior sessions.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(enforce, 400); });
  } else {
    setTimeout(enforce, 400);
  }

  // Re-check when tab regains focus (covers cart edits in another tab).
  window.addEventListener('focus', debouncedEnforce);

  // Expose for diagnostics.
  window.__ascendLimit = {
    enforce: enforce,
    stats: function () { return { enforcedCount: enforcedCount, running: running, lastFingerprint: lastFingerprint }; },
    variantIds: ASCEND_VARIANT_IDS
  };
})();
